export class PendingDriverRequest{
  userid: number = 0;
  memberid: number = 0;
  vanpool: string = "";
  hours: string;
  first_name: string = "";
  last_name: string = "";
  type: string = "";
}